module.exports = __webpack_public_path__ + "ivory-coast.svg?8c48118be69d435384d16e9d9e6dafa5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/ivory-coast.svg
// module id = 198
// module chunks = 10